<template>
  <div>
    <div :class="[$style.circle,{[$style.borderRed]: selectButton}]" @click="$emit('click', iAmArtist)">
      <i :class="[$style.faStyle, iAmArtist ? 'fa fa-search' : 'fa fa-users']"></i>
    </div>
    <p :class="$style.header">{{$t(iAmArtist ? 'text12' : 'text13')}}</p>
  </div>
</template>

<script>
  export default {
    name: "CircleButton",
    props: {
      iAmArtist: true,
      selectButton: true
    },
  }
</script>

<style lang="scss" module>
  .header {
    text-align: center;
    font-family: "Roboto", "Helvetica Neue", Arial, sans-serif !important;
    color: #565656;
  }
  .circle {
    text-align: center;
    vertical-align: middle;
    padding-right: 10px;
    height: 100px;
    width: 100px;
    border-radius: 50%;
    background-color: #999999;
    color: #FFFFFF;
    margin: 0 auto 20px;
    border: 4px solid #CCCCCC;
    -webkit-transition: all 0.2s;
    cursor: pointer;
    &:hover {
      border-color: #FB404B;
    }
  }
  .faStyle {
    // font-size: 30px;
    // line-height: 95px;
    display: inline-block;
    // width: 18px;
    text-align: center;
    font-size: 35px;
    line-height: 90px;
    width: 24px;
  }
  .borderRed {
    border-color: #FB404B;
  }
  /*.mouseHover {*/
    /*cursor: pointer;*/
  /*}*/
  /*.mouseHover:hover>div {*/
    /*border-color: #FB404B;*/
  /*}*/
</style>
